<template>
  <div>
    <el-alert
      title="开工会把设备改成维修中，完成或取消进行中的工单再改回运行。计划状态才能修改、开工和删除；计划和进行中可以取消。计划中和进行中的工单可以维护工具需求。"
      type="info" :closable="false" show-icon style="margin-bottom:12px"
    />
    <div class="toolbar">
      <el-input v-model="query.moCode" clearable placeholder="单号" style="width:160px" @keyup.enter.native="search" />
      <el-select v-model="query.moType" clearable placeholder="类型" style="width:110px">
        <el-option label="保养" value="01" />
        <el-option label="维修" value="02" />
      </el-select>
      <el-select v-model="query.moState" clearable placeholder="状态" style="width:120px">
        <el-option label="计划" value="00" />
        <el-option label="进行中" value="01" />
        <el-option label="完成" value="02" />
        <el-option label="取消" value="09" />
      </el-select>
      <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
      <el-button type="primary" icon="el-icon-plus" @click="openEdit()">新增</el-button>
    </div>
    <el-table :data="list" border v-loading="loading">
      <el-table-column prop="moCode" label="单号" width="180" />
      <el-table-column label="类型" width="80" align="center">
        <template slot-scope="{ row }">{{ row.moType === '01' ? '保养' : '维修' }}</template>
      </el-table-column>
      <el-table-column prop="machineName" label="设备" min-width="140" />
      <el-table-column prop="productionLineName" label="产线" width="120" />
      <el-table-column label="状态" width="90" align="center">
        <template slot-scope="{ row }">
          <el-tag size="small">{{ stateLabel(row.moState) }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="planStart" label="计划开始" width="170" />
      <el-table-column prop="staffName" label="负责人" width="100" />
      <el-table-column prop="sourceCostName" label="源成本" width="120" />
      <el-table-column label="操作" width="360" fixed="right" align="center">
        <template slot-scope="{ row }">
          <el-button type="text" @click="openTools(row)">工具</el-button>
          <el-button type="text" :disabled="row.moState !== '00'" @click="openEdit(row)">修改</el-button>
          <el-button type="text" :disabled="row.moState !== '00'" @click="startRow(row)">开工</el-button>
          <el-button type="text" :disabled="row.moState !== '01'" @click="finishRow(row)">完成</el-button>
          <el-button type="text" :disabled="row.moState !== '00' && row.moState !== '01'" @click="cancelRow(row)">取消</el-button>
          <el-button type="text" :disabled="row.moState !== '00'" :style="row.moState === '00' ? 'color:#ef4444' : ''" @click="onDelete(row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <list-pagination :total="total" :page="page" :page-size="pageSize" :page-sizes="[10, 20, 50, 100]" @current-change="onPage" @size-change="onSize" />

    <el-dialog :title="form.moId ? '修改维保工单' : '新增维保工单'" :visible.sync="visible" width="640px" :close-on-click-modal="false">
      <el-form :model="form" label-width="90px">
        <el-form-item label="单号"><el-input v-model="form.moCode" placeholder="留空自动生成" /></el-form-item>
        <el-form-item label="类型">
          <el-select v-model="form.moType" style="width:100%">
            <el-option label="保养" value="01" />
            <el-option label="维修" value="02" />
          </el-select>
        </el-form-item>
        <el-form-item label="设备">
          <el-select v-model="form.machineId" filterable style="width:100%">
            <el-option v-for="m in machines" :key="m.machineId" :label="m.machineCode + ' / ' + m.machineName" :value="m.machineId" />
          </el-select>
        </el-form-item>
        <el-form-item label="负责人">
          <el-select v-model="form.staffId" filterable clearable style="width:100%">
            <el-option v-for="s in staffs" :key="s.staffId" :label="s.staffNumber + ' / ' + s.staffName" :value="s.staffId" />
          </el-select>
        </el-form-item>
        <el-form-item label="源成本">
          <el-select v-model="form.sourceCostId" filterable clearable style="width:100%">
            <el-option v-for="c in costs" :key="c.sourceCostId" :label="c.sourceCostNumber + ' / ' + c.sourceCostName" :value="c.sourceCostId" />
          </el-select>
        </el-form-item>
        <el-form-item label="计划开始">
          <el-date-picker v-model="form.planStart" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" style="width:100%" />
        </el-form-item>
        <el-form-item label="计划结束">
          <el-date-picker v-model="form.planEnd" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" style="width:100%" />
        </el-form-item>
        <el-form-item label="问题描述"><el-input v-model="form.description" type="textarea" :rows="2" /></el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="visible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="submit">保存</el-button>
      </span>
    </el-dialog>

    <el-dialog :title="'工具需求 - ' + (toolMo.moCode || '')" :visible.sync="toolVisible" width="720px" :close-on-click-modal="false">
      <div style="margin-bottom:8px">
        <el-button v-if="canEditTools" type="primary" size="mini" @click="addToolLine">添加工具</el-button>
      </div>
      <el-table :data="toolLines" border size="small">
        <el-table-column label="工具" min-width="220">
          <template slot-scope="s">
            <el-select v-model="s.row.toolId" filterable :disabled="!canEditTools" style="width:100%">
              <el-option v-for="t in toolOptions" :key="t.toolId" :label="t.toolNumber + ' / ' + t.toolName" :value="t.toolId" />
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="数量" width="140">
          <template slot-scope="s">
            <el-input-number v-model="s.row.qty" :min="0.001" :precision="3" :disabled="!canEditTools" style="width:100%" />
          </template>
        </el-table-column>
        <el-table-column label="备注" min-width="140">
          <template slot-scope="s"><el-input v-model="s.row.remark" :disabled="!canEditTools" /></template>
        </el-table-column>
        <el-table-column label="操作" width="80" align="center">
          <template slot-scope="s">
            <el-button v-if="canEditTools" type="text" @click="toolLines.splice(s.$index, 1)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer">
        <el-button @click="toolVisible = false">关闭</el-button>
        <el-button v-if="canEditTools" type="primary" :loading="toolSaving" @click="saveTools">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import ListPagination from '../../components/ListPagination.vue'
import {
  listMaintenanceOrder, getMaintenanceOrder, saveMaintenanceOrder, updateMaintenanceOrder,
  deleteMaintenanceOrder, startMaintenanceOrder, finishMaintenanceOrder, cancelMaintenanceOrder
} from '../../api/maintenanceOrder'
import { selectMachine } from '../../api/machine'
import { selectStaff } from '../../api/staff'
import { selectSourceCost } from '../../api/sourceCost'
import { selectTool } from '../../api/tool'
import { listMoTool, saveMoTool } from '../../api/moTool'

function emptyForm() {
  return {
    moId: '', moCode: '', moType: '02', machineId: '', staffId: '', sourceCostId: '',
    planStart: null, planEnd: null, description: ''
  }
}

export default {
  components: { ListPagination },
  data() {
    return {
      query: { moCode: '', moType: '', moState: '' },
      list: [], total: 0, page: 1, pageSize: 20, loading: false, saving: false, visible: false,
      form: emptyForm(), machines: [], staffs: [], costs: [],
      toolVisible: false, toolSaving: false, toolMo: {}, toolLines: [], toolOptions: [], canEditTools: false
    }
  },
  created() {
    this.load()
    selectMachine().then(res => { this.machines = res.data || [] }).catch(() => {})
    selectStaff().then(res => { this.staffs = res.data || [] }).catch(() => {})
    selectSourceCost().then(res => { this.costs = res.data || [] }).catch(() => {})
  },
  methods: {
    stateLabel(v) { return { '00': '计划', '01': '进行中', '02': '完成', '09': '取消' }[v] || v },
    search() { this.page = 1; this.load() },
    onPage(p) { this.page = p; this.load() },
    onSize(s) { this.pageSize = s; this.page = 1; this.load() },
    load() {
      this.loading = true
      listMaintenanceOrder({
        currentPage: this.page, pageSize: this.pageSize,
        moCode: this.query.moCode, moType: this.query.moType, moState: this.query.moState
      }).then(res => {
        const body = res.data || {}
        this.list = body.list || []
        this.total = body.totalCount || 0
      }).finally(() => { this.loading = false })
    },
    openEdit(row) {
      if (!row) {
        this.form = emptyForm()
        this.visible = true
        return
      }
      if (row.moState !== '00') return
      getMaintenanceOrder(row.moId).then(res => {
        const d = res.data || {}
        this.form = {
          moId: d.moId, moCode: d.moCode, moType: d.moType || '02', machineId: d.machineId,
          staffId: d.staffId || '', sourceCostId: d.sourceCostId || '',
          planStart: d.planStart, planEnd: d.planEnd, description: d.description || ''
        }
        this.visible = true
      })
    },
    submit() {
      if (!this.form.machineId) { this.$message.warning('请选择设备'); return }
      this.saving = true
      const req = this.form.moId ? updateMaintenanceOrder(this.form) : saveMaintenanceOrder(this.form)
      req.then(() => {
        this.$message.success('保存成功')
        this.visible = false
        this.search()
      }).finally(() => { this.saving = false })
    },
    startRow(row) {
      if (!row || row.moState !== '00') return
      this.$confirm('确认开工? 设备将置为维修中', '提示', { type: 'warning' }).then(() => {
        startMaintenanceOrder(row.moId).then(() => { this.$message.success('操作成功'); this.load() })
      }).catch(() => {})
    },
    finishRow(row) {
      if (!row || row.moState !== '01') return
      this.$prompt('处理结果(可选)', '完成维保', { confirmButtonText: '确定', cancelButtonText: '取消' }).then(({ value }) => {
        finishMaintenanceOrder(row.moId, value || '').then(() => { this.$message.success('操作成功'); this.load() })
      }).catch(() => {})
    },
    cancelRow(row) {
      if (!row || (row.moState !== '00' && row.moState !== '01')) return
      this.$confirm('确认取消?', '提示', { type: 'warning' }).then(() => {
        cancelMaintenanceOrder(row.moId).then(() => { this.$message.success('操作成功'); this.load() })
      }).catch(() => {})
    },
    onDelete(row) {
      if (!row || row.moState !== '00') return
      this.$confirm('确定删除?', '提示', { type: 'warning' }).then(() => {
        deleteMaintenanceOrder([row.moId]).then(() => { this.$message.success('操作成功'); this.load() })
      }).catch(() => {})
    },
    openTools(row) {
      this.toolMo = row
      this.canEditTools = row.moState === '00' || row.moState === '01'
      this.toolLines = []
      this.toolVisible = true
      selectTool().then(res => { this.toolOptions = res.data || [] }).catch(() => {})
      listMoTool(row.moId).then(res => {
        this.toolLines = (res.data || []).map(line => ({
          toolId: line.toolId, qty: Number(line.qty || 1), remark: line.remark || ''
        }))
      }).catch(() => {})
    },
    addToolLine() { this.toolLines.push({ toolId: '', qty: 1, remark: '' }) },
    saveTools() {
      const lines = this.toolLines.filter(line => line.toolId)
      this.toolSaving = true
      saveMoTool({ moId: this.toolMo.moId, lines }).then(() => {
        this.$message.success('工具需求已保存')
        this.toolVisible = false
      }).finally(() => { this.toolSaving = false })
    }
  }
}
</script>
